import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import { UpOutlined, DownOutlined, SearchOutlined } from '@ant-design/icons';

import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {
  Col,
  Form,
  Input,
  Row,
  Modal,
  Button,
  Divider,
  Space,
  Typography,
  Image,
} from 'antd';
import Item from 'antd/lib/list/Item';
import { useForm } from 'antd/lib/form/Form';
import ShopList from '../../ShopList';
import { useSelector } from 'react-redux';
import { log } from 'console';

export type Props = {
  orders: any;
  type: string;
  onTabChangeState: (tabKey?: string) => any;
};

const MyOrders: React.FC<Props> = (props) => {
  const { orders = [], type } = props;
  let [formSearch] = Form.useForm();
  const [modalCancleShip, setModalCancleShip] = useState<boolean>(false);
  const [modalCheckCancel, setModalCheckCancel] = useState<boolean>(false);
  const [modalConfirmShip, setModalConfirmShip] = useState<boolean>(false);
  const navigate = useNavigate();
  const { Text } = Typography;
  const [myOrders, setMyOrders] = useState<any>([]);

  const [cancelShip, setCancelShip] = useState('');
  const [deliveredUpdateId, setDeliveredUpdateId] = useState('');
  const [statusOnCancel, setStatusOnCancel] = useState<string>('');
  const [allProducSeach, setAllProducSeach] = useState<any>();
  const [orderNo, setOrderNo] = useState('');
  const user = useSelector((state: any) => state.user);

  const [resonObject, setResonObject] = useState({
    reason: '',
    shopId: '',
  });

  const settothai = (status: string) => {
    let thaistatus = '';
    if (status === 'shop_prepare_delivery') {
      thaistatus = ' ผู้ขายกำลังเตรียมการจัดส่ง';
    } else if (status === 'on_delivery') {
      thaistatus = ' กำลังจัดส่ง';
    } else if (status === 'shop_delivered') {
      thaistatus = ' จัดส่งสำเร็จ';
    } else if (status === 'success') {
      thaistatus = ' เสร็จสิ้น';
    } else if (status === 'success_transfer') {
      thaistatus = ' เสร็จสิ้น';
    } else if (status === 'cancelled') {
      thaistatus = ' ยกเลิก';
    } else if (status === 'cancelled_transfer') {
      thaistatus = ' ยกเลิก';
    } else if (status === 'check_payment_cancel') {
      thaistatus = ' ตรวจสอบคำร้องขอยกเลิก';
    } else if (status === 'shop_prepare_delivery_cancel') {
      thaistatus = ' ตรวจสอบคำร้องขอยกเลิก';
    }
    return thaistatus;
  };

  const reasonShop = (type: string, remark?: string) => {
    //// เหตุผลข้างปุ่มต่างๆ////
    // console.log("myOrders.reason : ", remark);
    let reason = ' ';
    if (type === 'shop_prepare_delivery') {
      ///ผู้ขายกำลังเตรียมการจัดส่ง
      reason = ` คำสั่งซื้อของท่านอยู่ระหว่างเตรียมการจัดส่ง`;
    } else if (type === 'on_delivery') {
      //กำลังจัดส่ง
      reason = ` คำสั่งซื้อของท่านอยู่ระหว่างจัดส่งท่านจะได้รับสินค้าภายใน 7 วันหลังการชำระเงิน`;
    } else if (type === 'shop_delivered') {
      //จัดส่งสำเร็จ
      reason = ` คำสั่งซื้อของท่านจัดส่งสำเร็จแล้วกรุณาตรวจสอบสินค้าและยืนยันรับสินค้า`;
    } else if (type === 'success') {
      //เสร็จสิ้น
      reason = ` คำสั่งซื้อของท่านจัดส่งสำเร็จแล้ว`;
    } else if (type === 'success_transfer') {
      //เสร็จสิ้น
      reason = ` คำสั่งซื้อของท่านจัดส่งสำเร็จแล้ว`;
    } else if (type === 'check_payment_cancel') {
      reason = ` คำสั่งซื้อของท่านอยู่ระหว่างตรวจสอบคำร้องขอยกเลิก : ${remark}`;
    } else if (type === 'shop_prepare_delivery_cancel') {
      reason = ` คำสั่งซื้อของท่านอยู่ระหว่างตรวจสอบคำร้องขอยกเลิก : ${remark}`;
    } else if (type === 'cancelled' || type === 'cancelled_transfer') {
      reason = `คำสั่งซื้อถูกยกเลิกเนื่องจาก : ${
        remark !== undefined ? remark : ''
      }`;
    }
    return reason;
  };

  const changeStatusToCancel = async () => {
    const data = {
      reason: `จากผู้ซื้อ, ${resonObject.reason}`,
      cancelOrder: true,
      status: `${statusOnCancel}_cancel`,
    };

    await axios.patch(`/ordershops/${resonObject.shopId}`, data);
    window.location.reload();
  };

  const changeStatusToDelivered = async () => {
    const data = {
      status: 'success',
    };
    if (deliveredUpdateId) {
      const shopId = {
        orderShopId: `${deliveredUpdateId}`,
      };

      await axios.patch(`/ordershops/${deliveredUpdateId}`, data);
      await axios.post(`/ordershops/create-order-transfer`, shopId);
    }

    //sale transaction scg family
    const order = await axios.get(`/ordershops/order-number/${orderNo}`);

    const body = {
      data: order.data,
      type: 'online',
    };

    await axios.post(`/scg-family/sale-transaction`, body);
    window.location.reload();
  };

  // const V2 = async () => {
  //   const data = {
  //     status: "success",
  //   };
  //   if (deliveredUpdateId) {
  //     // console.log("deliveredUpdateId", deliveredUpdateId);
  //     const shopId = {
  //       orderShopId: `${deliveredUpdateId}`,
  //     };
  //     await axios.patch(`/ordershops/${deliveredUpdateId}`, data);
  //     await axios.post(`/ordershops/create-order-transfer`, shopId);
  //   }

  //   // await axios.patch(`/ordershops/${resonObject.shopId}`, data);
  //   window.location.reload();
  // };

  const sentState = (value?: string) => {
    // console.log("sent....");
    props.onTabChangeState(value);
  };
  const onClickModalConfirmDelivered = (order: any, index: number) => {
    setModalConfirmShip(true);
    setDeliveredUpdateId(order._id);
    setOrderNo(order?.orderNo ? order?.orderNo : order?._id);
  };

  const onClickModalCancel = (order: any, index: number) => {
    setStatusOnCancel(order.status);
    if (order.status === 'on_delivery') {
      setModalCancleShip(true);
    } else if (order.status === 'on_delivery') {
      setModalCancleShip(true);
    }

    setResonObject({
      ...resonObject,
      shopId: order._id,
    });
  };
  const onReasonChange = (e: any) => {
    const value = e.target.value;
    setResonObject({
      ...resonObject,
      reason: value,
    });
  };

  const onCollapedClick = (order: any, index: number) => {
    const odrs: any = myOrders.map((x: any) => ({
      ...x,
      isCollaped: x._id === order._id ? !order.isCollaped : x.isCollaped,
    }));
    setMyOrders(odrs);
  };

  const searchOrder = (values: any) => {
    const value = values.toLowerCase();
    setAllProducSeach(value);
  };
  const searchButton = async (e: any) => {
    let check = e.key ? e.key : e;
    if (check === 'Enter') {
      let newOrder = [];
      let value = allProducSeach;
      // console.log(value);
      for (let i = 0; i < orders.length; i++) {
        try {
          const matchText = orders[i]._id.toLowerCase().match(value);
          const matchText1 = orders[i].orderNo.toLowerCase().match(value);
          const matchText2 = orders[i].shop.name.toLowerCase().match(value);

          const matchText3 = orders[i].products.some((productArray: any) =>
            Object.values(productArray).some((obj: any) => {
              let hasProductName = false;
              if (obj._id) {
                hasProductName = obj._id.product.productName
                  .toLowerCase()
                  .includes(value);
              }
              return hasProductName;
            })
          );

          if (matchText) {
            newOrder.push(orders[i]);
          } else if (matchText1) {
            newOrder.push(orders[i]);
          } else if (matchText2) {
            newOrder.push(orders[i]);
          } else if (matchText3) {
            newOrder.push(orders[i]);
          }
        } catch (error: any) {
          // console.log('catch fetchUserInfo => ');
          // alert('Get current info failed!, ' + error.message);
        }
      }
      if (newOrder) {
        setMyOrders(newOrder);
      }
    }
  };

  useEffect(() => {
    ///console.log("check orders in component =>", orders);

    const odrs = orders.map((x: any) => ({
      ...x,
      isCollaped: true,
    }));
    setMyOrders(odrs);
    // console.log("orders", orders);
    formSearch.setFieldsValue({ search: null });
  }, [orders]);

  const plustime = (time: string) => {
    let xtime = time?.substring(0, 2);
    let date = time?.substring(2, 6);
    let conint = parseInt(xtime) + 1;
    let datetime = conint.toString() + date;

    return datetime;
  };

  return (
    <>
      <Row justify='space-around'>
        <Col span={22}>
          <Form form={formSearch}>
            <Form.Item name='search' noStyle>
              <Input
                name='search'
                onChange={(e) => {
                  searchOrder(e.target.value);
                }}
                placeholder='ค้นหาสินค้า'
                onKeyDown={(e) => {
                  searchButton(e);
                }}
              />
            </Form.Item>
          </Form>
        </Col>
        <Col span={2}>
          <Button
            type='primary'
            onClick={() => {
              searchButton('Enter');
            }}
            className={styles.inputSearch}
            style={{ marginLeft: 5 }}
          >
            <SearchOutlined />
          </Button>
        </Col>
      </Row>
      {myOrders.map((order: any, indexOrder: number) => (
        <div className={styles.detailproduct}>
          <div key={indexOrder} className={styles.containerbox}>
            {/* {console.log("orderx", order)} */}
            <Row justify='space-between' style={{ paddingTop: '10px' }}>
              <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                <Row>
                  <Col xs={24} sm={24} md={4} lg={6} xl={6}>
                    {/* <img src={`/images/account_box_24px.svg`} /> */}
                    <img
                      src={
                        order.shop?.document?.shopImageUrl == undefined
                          ? '/images/account_box_24px.svg'
                          : order.shop?.document?.shopImageUrl
                      }
                      height={35}
                      alt=''
                    />
                    &nbsp;
                    {order?.shop?.name}
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={6}
                    lg={8}
                    xl={7}
                    style={{ marginTop: '5px' }}
                  >
                    {order.deliveryType !== undefined
                      ? 'ตัวเลือกจัดส่ง: ' + order.deliveryType
                      : ''}
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={10}
                    lg={10}
                    xl={9}
                    style={{ marginTop: '5px' }}
                  >
                    <Text style={{ color: '#2D6FA5', fontSize: 12 }}>
                      {order.order?.orderType !== 'order_offline' &&
                      order.shipmentDate !== undefined
                        ? '(' +
                          order.shipmentDate +
                          ' เวลา ' +
                          order.shipmentTime +
                          '-' +
                          plustime(order.shipmentTime) +
                          'น.)'
                        : order.order?.orderType === 'order_offline' &&
                          order.deliveryType === 'จัดส่งปกติ'
                        ? `(เวลา ${order.shipmentPeriod} น.)`
                        : ''}
                      {/* {order.shipmentDate !== undefined
                        ? "( " +
                        order.shipmentDate +
                        " เวลา " +
                        order.shipmentTime +
                        "-" +
                        plustime(order.shipmentTime) +
                        "น.)"
                        : ""} */}
                    </Text>
                  </Col>
                </Row>
              </Col>
              <Col style={{ marginTop: '5px' }}>
                <Space align='end'>
                  <Row>
                    <Col style={{ fontSize: 12 }}>
                      {order?.orderNo ? order?.orderNo : order?._id}
                      {/* {order._id} |  */}
                    </Col>
                    <Col style={{ fontSize: 12, color: '#2D6FA5' }}>
                      &nbsp; {settothai(order.status)}
                    </Col>
                  </Row>
                </Space>
              </Col>
            </Row>

            <div
              className={styles.productWrapper}
              //style={{ height: shop.isCollaped ? 0 : 500 }}
            >
              {order.isCollaped ? (
                <>
                  <div>
                    <Row
                      className={styles.detailproduct}
                      justify='space-between'
                      style={{ paddingTop: '10px' }}
                    >
                      <Col>
                        <Image
                          width={100}
                          src={
                            order.products[0]?.product._id?.product?.files[0]
                          }
                        />
                      </Col>
                      <Col xs={8} sm={18} md={18} lg={18} xl={19}>
                        <Col>
                          <Text>
                            {
                              order.products[0]?.product._id?.product
                                ?.productName
                            }
                          </Text>
                        </Col>
                        <Col style={{ marginTop: '15px' }}>
                          <Text style={{ color: '#828282' }}>
                            {' '}
                            {order.products[0]?.amount} ชิ้น
                          </Text>
                        </Col>
                      </Col>
                      <Col xs={4} sm={2} md={2} lg={2} xl={2}>
                        <Space align='end'>
                          <Text style={{ color: '#2D6FA5' }}>
                            ฿ {order.products[0]?.wholesalePrice}
                          </Text>
                        </Space>
                      </Col>
                    </Row>
                  </div>
                  <div className={styles.boxborderbutton}></div>
                </>
              ) : (
                <>
                  {order.products.map((products: any, productIndex: number) => (
                    <div className={styles.productItem} key={productIndex}>
                      <Row
                        className={styles.detailproduct}
                        justify='space-between'
                        style={{ paddingTop: '10px' }}
                      >
                        <Col>
                          <Image
                            width={100}
                            src={products?.product?._id?.product?.files[0]}
                          />
                        </Col>
                        <Col xs={8} sm={18} md={18} lg={18} xl={19}>
                          <Col>
                            <Text>
                              {products?.product?._id?.product?.productName}
                            </Text>
                          </Col>
                          <Col style={{ marginTop: '55px' }}>
                            <Text style={{ color: '#828282' }}>
                              {' '}
                              {products.amount} ชิ้น
                            </Text>
                          </Col>
                        </Col>
                        <Col xs={4} sm={2} md={2} lg={2} xl={2}>
                          <Space align='end'>
                            <Text style={{ color: '#2D6FA5' }}>
                              ฿ {products.wholesalePrice}
                            </Text>
                          </Space>
                        </Col>
                      </Row>
                    </div>
                  ))}
                  <div className={styles.boxborderbutton}></div>
                  <div>
                    <Row justify='space-between' style={{ margin: '10px 0px' }}>
                      <Space align='start'>
                        <Text>
                          โน้ตที่ส่งถึงร้านค้า: &nbsp;
                          {order.remark}
                        </Text>
                      </Space>

                      <Space align='end'>
                        <Text>ค่าขนส่ง </Text>
                        <Text style={{ color: '#2D6FA5' }}>
                          ฿{order?.shipment}
                        </Text>
                      </Space>
                    </Row>

                    <Row justify='space-between' style={{ margin: '10px 0px' }}>
                      <Space align='start'>
                        <Text>
                          สถานที่จัดส่ง : &nbsp;{order?.order?.address?.address}
                          &nbsp;อ.{order?.order?.address?.subCity?.name}
                          &nbsp;ต.{order?.order?.address?.city?.name}
                          &nbsp;จ.{order?.order?.address?.state?.name}
                          &nbsp; {order?.order?.address?.postalCode}
                        </Text>
                      </Space>

                      <Space align='end'>
                        <Text>ส่วนลด </Text>
                        <Text style={{ color: '#2D6FA5' }}>
                          ฿ {order.discount}
                        </Text>
                      </Space>
                    </Row>

                    <Row justify='space-between' style={{ margin: '10px 0px' }}>
                      <Space align='start'>
                        <Text>
                          วันที่สั่งซื้อ : &nbsp; {order.formatCreatedAt}
                        </Text>
                      </Space>

                      <Space align='end'>
                        <Text>ทั้งหมด </Text>
                        <Text style={{ color: '#2D6FA5' }}>
                          ฿{order.totalPrice}
                        </Text>
                      </Space>
                    </Row>
                  </div>
                </>
              )}
            </div>
            <>
              {' '}
              {indexOrder > 0 ? (
                <div className={styles.boxborderbutton}></div>
              ) : (
                ''
              )}
              {/* )} */}
              <div
                className={styles.hiddingtabs}
                onClick={() => {
                  //   const odrs: any = myOrders;
                  //   odrs[indexOrder].isCollaped = !odrs[indexOrder].isCollaped;
                  //   console.log("odrs =>>", odrs);

                  //   setMyOrders(odrs);

                  onCollapedClick(order, indexOrder);

                  //   setMyOrders({ ...odrs });

                  //   order.isCollaped = !order.isCollaped;
                }}
              >
                {order.isCollaped ? (
                  <div>
                    ดูรายละเอียดเพิ่มเติม &nbsp;
                    <DownOutlined />
                  </div>
                ) : (
                  <div>
                    ซ่อนรายละเอียด &nbsp;
                    <UpOutlined />
                  </div>
                )}
              </div>
            </>
            <div className={styles.boxborderbutton}></div>
            <Row justify='space-between' style={{ margin: '10px 0px' }}>
              <Space align='start'>
                <Text style={{ color: '#2D6FA5' }}>
                  {reasonShop(order.status, order.reason)}
                </Text>
              </Space>
              <Space align='start'>
                <Text style={{ color: '#2D6FA5' }}>
                  <br />
                  {order.status === 'shipping' ? order.remarksub : ''}
                </Text>
              </Space>

              <Space align='end'>
                {type === 'shop_prepare_delivery' && (
                  <Button
                    type='primary'
                    ghost
                    onClick={() => {
                      setCancelShip('');
                      onClickModalCancel(order, indexOrder);
                      setModalCancleShip(true);
                    }}
                  >
                    ยกเลิกคำสั่งซื้อ
                  </Button>
                )}
                {type === 'shop_delivered' && (
                  <Button
                    type='primary'
                    onClick={() => {
                      onClickModalConfirmDelivered(order, indexOrder);
                    }}
                  >
                    ยืนยันรับสินค้า
                  </Button>
                )}

                {type === 'checkCancel' && (
                  <Button
                    type='primary'
                    ghost
                    onClick={() => {
                      onClickModalCancel(order, indexOrder);
                      // setModalCheckCancel(true);
                    }}
                  >
                    ยกเลิกคำร้องขอยกเลิก
                  </Button>
                )}
              </Space>
            </Row>

            {/* <div className={styles.boxborderbuttomline}></div> */}
            {/*modal confirmship cancelled tab1*/}
          </div>
          <Divider style={{ backgroundColor: '#d9d9d9' }}></Divider>
        </div>
      ))}

      {/* {prepareship} */}
      <Modal
        title=''
        centered
        visible={modalCancleShip}
        onOk={() => ''}
        onCancel={() => setModalCancleShip(false)}
        footer={null}
        width={336}
      >
        <Row justify='center'>
          <Text>กรุณากรอกสาเหตุที่ยกเลิก</Text>
        </Row>
        <Row justify='space-around' style={{ marginTop: '10px' }}>
          <Form.Item
            rules={[
              {
                required: true,
                message: 'กรุณากรอกข้อมูล!',
              },
            ]}
          >
            <Input
              className={styles.inputtextcancle}
              type='text'
              value={cancelShip}
              placeholder='กรุณากรอกสาเหตุ'
              name='CancleTextShipModal'
              onChange={(e: any) => {
                onReasonChange(e);
                setCancelShip(e.target.value);
                // console.log("e=>", e.target.value);
                // setReasonCancelShip(e.target.value);
              }}
            />
            <Button
              type='primary'
              className={styles.button_submit}
              onClick={() => {
                if (cancelShip !== '') {
                  setModalCancleShip(false);
                  changeStatusToCancel();
                  sentState('cancelled');
                }
              }}
            >
              ตกลง
            </Button>
          </Form.Item>
        </Row>
      </Modal>
      {/* {ConfirmAcceptCate} */}
      <Modal
        title=''
        centered
        visible={modalConfirmShip}
        onOk={() => ''}
        onCancel={() => setModalConfirmShip(false)}
        footer={null}
        width={336}
      >
        <Row justify='center'>
          <Text>ท่านได้ตรวจสอบสินค้าและยืนยันการรับสินค้า</Text>

          <Button
            type='primary'
            className={styles.button_submit}
            onClick={() => {
              setModalConfirmShip(false);
              changeStatusToDelivered();
              sentState('success');
            }}
          >
            ตกลง
          </Button>
        </Row>
      </Modal>
      {/* {CancelCheck} */}
      <Modal
        title=''
        centered
        visible={modalCheckCancel}
        onOk={() => ''}
        onCancel={() => setModalCheckCancel(false)}
        footer={null}
        width={336}
      >
        <Row justify='center'>
          <Text>กรุณากรอกสาเหตุที่ยกเลิก{}</Text>
        </Row>
        <Row justify='space-around' style={{ marginTop: '10px' }}>
          <Form.Item
            name='CancleCheckModal'
            rules={[
              {
                required: false,
                message: 'กรุณากรอกข้อมูล!',
              },
            ]}
          >
            <Input
              className={styles.inputtextcancle}
              type='text'
              name='CancleCheckModal'
            />
          </Form.Item>
        </Row>
        <Row justify='space-around'>
          <Button
            type='primary'
            className={styles.button_submit}
            onClick={() => {
              setModalCheckCancel(false);
              //sentState("6"); ยย้อนโฟล
            }}
          >
            ตกลง
          </Button>
        </Row>
      </Modal>
    </>
  );
};

export default MyOrders;
